import { useCreateEntity } from '@abaninja/util-store';

import { migrateAccountToNinjabox } from '../accounts';

export const useAccountMigrationStore = () => {
  const {
    createEntity,
    isCreating,
  } = useCreateEntity(migrateAccountToNinjabox);

  return {
    beginMigration: createEntity,
    isCreating,
  };
};
